import React from 'react';
import { useState, useEffect } from 'react';
import PageTitle from '../../common/components/PageTitle';
import { selectUser } from '../../common/auth/UserSlice';
import { useSelector } from 'react-redux';
import { Typography, CircularProgress } from '@mui/material';
import { Stack, Paper, Divider, Button, Grid, Link } from '@mui/material';
import { styled } from '@mui/system';
import { AvatarDisplay } from '../../common/components/AvatarDisplay';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from '../../common/snackbar/SnackbarActions';
import { handleValidateReferral } from '../../common/subscription/SubscriptionService';
import { EXT_REF_TOS } from '../../routes/CONSTANTS';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
}));

const LeftItem = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  borderRadius: 0,
  margin: theme.spacing(0.5),
  width: '98%',
  textAlign: 'left',
}));

export function Refer() {
  const userInfo = useSelector(selectUser);
  const [referralLink, setReferralLink] = useState('');
  const [canRefer, setCanRefer] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setReferralLink(
      'https://app.linktivitylearning.com/sign-up/' + userInfo.sub
    );
    handleValidateReferral(userInfo.sub)
      .then((res) => {
        setCanRefer(res);
      })
      .catch((err) => {
        console.err(err);
        setCanRefer(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userInfo.sub]);

  const handleCopyToClipboardClick = (event) => {
    event.preventDefault();
    try {
      navigator.clipboard.writeText(referralLink);
      showSuccessSnackbar('Link copied');
    } catch (err) {
      console.error(err.message);
      showErrorSnackbar('Link copy failed');
    }
  };

  return (
    <>
      <PageTitle title='Refer a Friend' />
      <Grid
        container
        alignItems='flex-start'
        justifyContent='center'
        direction='row'
      >
        <Grid item xs={0} md={1} lg={2} xl={3}></Grid>
        <Grid item xs={12} md={5} lg={4} xl={3}>
          <AvatarDisplay />
        </Grid>
        <Grid item xs={12} md={5} lg={4} xl={3}>
          {loading ? (
            <Grid container spacing={10}>
              <Grid item xs={12}>
                <CircularProgress color='secondary' />
              </Grid>
            </Grid>
          ) : canRefer ? (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h6'>
                  Use the link below to refer someone to LINKtivity® Learning
                </Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <LeftItem>
                <Typography>
                  <b>Referral Link</b>
                  <br /> {referralLink}
                </Typography>
                <Button
                  variant='contained'
                  color='secondary'
                  onClick={handleCopyToClipboardClick}
                >
                  <ContentCopyIcon style={{ marginRight: '5' }} />
                  COPY LINK
                </Button>
                <Typography>
                  If you share this unique referral link with someone and they
                  use it to sign-up, you'll receive a one-time credit that will
                  be reflected in your future invoices. In addition, the person
                  you refer will receive a special promotional discount. The{' '}
                  <Link href={EXT_REF_TOS} target='_blank' rel='noreferrer'>
                    referral terms and conditions
                  </Link>{' '}
                  apply.
                </Typography>
              </LeftItem>
            </Stack>
          ) : (
            <Stack alignItems='center' justifyContent='center'>
              <Item>
                <Typography variant='h6'>Referral Not Available</Typography>
              </Item>
              <Item sx={{ width: '50%' }}>
                <Divider />
              </Item>
              <LeftItem>
                <Typography>
                  Your account is currently not eligible for referral benefits,
                  but you can still spread the word! See the{' '}
                  <Link href={EXT_REF_TOS} target='_blank' rel='noreferrer'>
                    referral terms and conditions
                  </Link>{' '}
                  for details about referral availability.
                </Typography>
              </LeftItem>
            </Stack>
          )}
        </Grid>
        <Grid item xs={0} md={1} lg={2} xl={3}></Grid>
      </Grid>
    </>
  );
}
